module.exports = __webpack_public_path__ + "static/annie-headshot-a674464db1e2e69f63acb6f81d8e5951.png";